const setFontUrl = ({ articleId, totalArticles }) => {
  const currentArticleId = articleId;
  const nextArticleId = (articleId % totalArticles) + 1;

  const getFontById = id => {
    switch (id) {
      case 1:
        return "https://highsnobiety-interactive-stories.s3.us-east-1.amazonaws.com/2025-04-trident-article/fonts/outward_block.json";
      case 2:
        return "https://highsnobiety-interactive-stories.s3.us-east-1.amazonaws.com/2025-04-trident-article/fonts/thunder_black_regular.json";
      case 3:
        return "https://highsnobiety-interactive-stories.s3.us-east-1.amazonaws.com/2025-04-trident-article/fonts/being_regular_regular_2.json";
      default:
        return "https://highsnobiety-interactive-stories.s3.us-east-1.amazonaws.com/2025-04-trident-article/fonts/outward_block.json";
    }
  };

  const currentFontUrl = getFontById(currentArticleId);
  const nextArticleFontUrl = getFontById(nextArticleId);
  const ctaUrl =
    "https://highsnobiety-interactive-stories.s3.us-east-1.amazonaws.com/2025-04-trident-article/fonts/editorial_new_regular.json";

  return { currentFontUrl, nextArticleFontUrl, ctaUrl };
};

export { setFontUrl };
